// @flow
import { styled } from 'goober';
import { useEffect } from 'preact/hooks';
import { Fragment } from 'preact';
import CustomSplitInput from '../checkoutWidget/CustomSplitInput';
import { device } from '../../utils/breakPoints';
import ResendTimer from './ResendTimer';
import SaCustomButton from './SaCustomButton';
import { useSalesAppTracker } from './tracker';

const OtpContainer = styled('div')`
  .container {
    padding: 50px 16px 30px 16px;
  }

  .heading {
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: var(--primaryCTAColor);
  }

  .subHeading {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    padding: 10px 0px 0px 0px;
    color: #636363;
  }

  .change {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.2px;
    text-decoration-line: underline;
    color: #1a73e8;
    margin-left: 5px;
    cursor: pointer;
  }

  .otpInput input {
    width: 60.04px !important;
    height: 60px !important;
    font-size: 20px !important;
  }

  .timerContainer {
    width: fit-content;
  }

  .attemptsWarning {
    margin-bottom: 84px;
  }

  .btnContainer {
    margin: 30px 0px 0px;
    display: flex;
    justify-content: center;
  }

  ${device.mobileM`
.otpInput input {
  width: 60.04px !important;
  height: 60px !important;
  font-size: 20px !important;
}
`}
  ${device.mobileL`
.otpInput input {
  width: 60.04px !important;
  height: 60px !important;
}
`}

@media screen and (min-width: 320px) and (max-width: 360px) {
    .otpInput input {
      width: 50.04px !important;
      height: 50px !important;
    }
  }
`;

const EnterOtpScreen = ({
  mobileNo,
  handleChangeMobile,
  btnHandler,
  resendOtpHandler,
  btnTxt,
  onChangeHandler,
  otpValue,
  loading,
  remainingAttempts,
  openToast,
}) => {
  const pageKey = 'sa_pv_share_code_modal';
  const salesAppTracker = useSalesAppTracker(pageKey);
  useEffect(() => {
    salesAppTracker.trackPageView('sa_pv_share_code_modal');
  }, []);
  return (
    <OtpContainer>
      <div className='container'>
        <div className='heading'>Enter Secure Share Code</div>
        <div className='subHeading'>
          Sent on customers mobile no. +91 {mobileNo}
          <span
            className='change'
            onClick={() => {
              salesAppTracker.trackClick('sa_click_change_mobile', undefined);
              handleChangeMobile();
              openToast(false);
            }}>
            Change
          </span>
        </div>
        <CustomSplitInput
          numInputs={5}
          isInputNum={true}
          onChange={onChangeHandler}
          value={otpValue}
          separator={<Fragment>&nbsp;</Fragment>}
          shouldAutoFocus={true}
          className='otpInput'
        />
        <div className='timerContainer subHeading helpText'>
          <ResendTimer
            resendOTP={() => {
              salesAppTracker.trackClick(
                'sa_click_resend_share_code',
                undefined,
              );
              resendOtpHandler();
            }}
            additionalText='Resend Share Code in'
          />
        </div>
        <div className='subHeading attemptsWarning'>
          {!!remainingAttempts && remainingAttempts !== 0
            ? remainingAttempts < 4
              ? `Last ${remainingAttempts} ${
                  remainingAttempts === 1 ? 'attempt' : 'attempts'
                } remaining`
              : null
            : null}
        </div>
        <SaCustomButton
          disable={!!!otpValue || otpValue.length !== 5}
          onClick={() => {
            salesAppTracker.trackClick('sa_click_submit_share_code', undefined);
            btnHandler();
          }}
          name={btnTxt}
          loading={loading}
          containerClass='btnContainer'
        />
      </div>
    </OtpContainer>
  );
};
export default EnterOtpScreen;



// WEBPACK FOOTER //
// ./components/salesApp/EnterOtpScreen.js